import script from "./PackageCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PackageCard.vue?vue&type=script&setup=true&lang=js"

import "./PackageCard.vue?vue&type=style&index=0&id=74e985f9&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74e985f9"]])

export default __exports__